import { render, staticRenderFns } from "./CtaContact.vue?vue&type=template&id=e4e0aa7a"
import script from "./CtaContact.vue?vue&type=script&lang=js"
export * from "./CtaContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports